import type { TLngLat } from 'App/Map/types'
import { ExternalVendorIcons } from 'components/ExternalVendorIcons/ExternalVendorIcons'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TPropertyId } from 'stores/fieldAssetStore/helperTypes'
import type { TPointDeviceKind } from 'utils/getPointExternalVendorNames'
import { getPointExternalVendorNames } from 'utils/getPointExternalVendorNames'

export const PointVendorIcons = ({
  propertyId,
  lngLat,
  deviceKind,
}: {
  propertyId: TPropertyId
  lngLat: TLngLat
  deviceKind: TPointDeviceKind
}) => {
  const point = fieldAssetStore.useSelector((s) => s.properties?.[propertyId]?.points?.[lngLat])
  const externalVendorNames = getPointExternalVendorNames({ point, deviceKind })

  if (!externalVendorNames?.length) return null

  return <ExternalVendorIcons externalVendorNames={externalVendorNames} size={20} />
}
